export const isValidPhone = (phone) => {
    const phoneRegex = /^\+?[1-9]\d{1,14}$/;
    return phoneRegex.test(phone);
};

export const validateWhatsappForm = (data, templateParams = { header: {}, body: {} }, headerVariables = [], bodyVariables = []) => {
    const errors = {
        to: '',
        body: '',
        templateParams: {
            header: {},
            body: {}
        }
    };

    // Validate phone
    if (!data.to || data.to.trim() === '') {
        errors.to = 'Phone number is required';
    } else if (!isValidPhone(data.to.trim())) {
        errors.to = 'Please enter a valid phone number';
    }

    // Validate body
    if (!data.body || data.body.trim() === '') {
        errors.body = 'Message body is required';
    } else if (data.body.trim().length < 10) {
        errors.body = 'Message body must be at least 10 characters';
    } else if (data.body.length > 1000) {
        errors.body = 'Message body must not exceed 1000 characters';
    }

    // Validate template params for header variables
    headerVariables.forEach(v => {
        if (!templateParams.header || !templateParams.header[v] || templateParams.header[v].trim() === '') {
            errors.templateParams.header[v] = 'This field is required';
        }
    });

    // Validate template params for body variables
    bodyVariables.forEach(v => {
        if (!templateParams.body || !templateParams.body[v] || templateParams.body[v].trim() === '') {
            errors.templateParams.body[v] = 'This field is required';
        }
    });

    return errors;
};

export const hasValidationErrors = (errors) => {
    if (!errors) return false;
    const check = (obj) => {
        return Object.values(obj).some(value => {
            if (typeof value === 'string') return value !== '';
            if (typeof value === 'object') return check(value);
            return false;
        });
    };
    return check(errors);
};

